
import React from "react";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import FlowStep from "./FlowStep";
import LegatiaCoordination from "./LegatiaCoordination";

const MoneyFlowDiagram = () => {
  const { language } = useLanguage();
  const content = {
    fr: {
      family: "Famille",
      bank: "Banque",
      child: "Enfant à 18 ans",
      coordination: "Fait de votre contribution un cadeau inoubliable"
    },
    en: {
      family: "Family",
      bank: "Banque", 
      child: "Child at 18",
      coordination: "Makes your contribution an unforgettable gift"
    },
    de: {
      family: "Familie",
      bank: "Banque",
      child: "Kind mit 18",
      coordination: "Macht Ihren Beitrag zu einem unvergesslichen Geschenk"
    }
  };

  const EnhancedArrow = ({ delay = "0s" }: { delay?: string }) => (
    <div className="flex items-center justify-center">
      <div className="relative">
        <div className="absolute inset-0 blur-sm">
          <ArrowRight className="h-8 w-8 md:h-10 md:w-10 text-legatia-orange/60 rotate-90 md:rotate-0" />
        </div>
        <ArrowRight 
          className="relative h-8 w-8 md:h-10 md:w-10 text-legatia-orange rotate-90 md:rotate-0 drop-shadow-md animate-pulse" 
          style={{ animationDelay: delay }} 
        />
      </div>
    </div>
  );

  return (
    <div className="flex flex-col items-center justify-center gap-8 md:gap-12 py-8 md:py-12">
      {/* Enhanced Money flow: Family → Bank → Child */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 w-full max-w-5xl">
        
        {/* Family Step */}
        <FlowStep
          imageUrl="/lovable-uploads/45fb1197-c9cb-4463-bf79-e8c17b672a51.png"
          imageAlt="Family"
          label={content[language].family}
          gradientFrom="from-legatia-orange"
          gradientTo="to-legatia-yellow"
        />

        {/* Enhanced Arrow 1 */}
        <EnhancedArrow />

        {/* Bank Step */}
        <FlowStep
          imageUrl="/lovable-uploads/b73e4d24-5326-47ab-96b5-d909c887ca3a.png"
          imageAlt="Bank"
          label={content[language].bank}
          gradientFrom="from-legatia-yellow"
          gradientTo="to-legatia-green"
        />

        {/* Enhanced Arrow 2 */}
        <EnhancedArrow delay="0.5s" />

        {/* Child at 18 Step */}
        <FlowStep
          imageUrl="/lovable-uploads/7e1ab58d-dd2a-4f0e-98a1-8d6e72f5311c.png"
          imageAlt="Child at 18"
          label={content[language].child}
          gradientFrom="from-legatia-green"
          gradientTo="to-legatia-blue"
        />
      </div>

      {/* Enhanced Legatia coordination note */}
      <LegatiaCoordination coordinationText={content[language].coordination} />
    </div>
  );
};

export default MoneyFlowDiagram;
